var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"font-weight-medium"},[_c('div',{staticClass:"d-flex header-row"},[_c('div',{staticClass:"list-column email"},[_vm._v("Email")]),_c('div',{staticClass:"list-column date"},[_vm._v("Created at")])])])}
var staticRenderFns = []

export { render, staticRenderFns }